export default __webpack_public_path__ + "static/media/candcholder.31e08d2c.jpg";